module.exports = __webpack_public_path__ + "img/finish-matte-silver.ecd3b127.jpg";